import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const ImageCarousal = ({ images = [], title }) => {



    return (
        <div className="relative w-full h-[250px] sm:h-[350px] md:h-[450px] lg:h-[620px]">
            {/* Carousel */}
            <Swiper
                spaceBetween={20}
                centeredSlides={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="w-full h-full rounded-lg overflow-hidden"
            >
                {images.map((img, index) => (
                    <SwiperSlide
                        key={index}
                        className="flex items-center justify-center"
                    >
                        <img
                            src={img}
                            alt={`slide-${index}`}
                            className="w-full h-full object-cover"
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Fixed Text Overlay */}
            <div className="absolute inset-0 flex items-center justify-center z-10 bg-[#5E35B14D] text-center px-4">
                <h2 className="text-white text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-extrabold drop-shadow-lg">
                    {title}
                </h2>
            </div>
        </div>

    )
}

export default ImageCarousal